import { render, staticRenderFns } from "./WaitingTab.vue?vue&type=template&id=1945bdc5&scoped=true"
import script from "./WaitingTab.vue?vue&type=script&lang=ts"
export * from "./WaitingTab.vue?vue&type=script&lang=ts"
import style0 from "./WaitingTab.vue?vue&type=style&index=0&id=1945bdc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1945bdc5",
  null
  
)

export default component.exports